// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid{
  width:100%;
  height:100%;
}

.editItem {
  border: 1px solid black;
  align-content: center;
  min-width: 20px;
  min-height: 20px;
}

.dragPoint{
    position:absolute;
    top:5px;
    right:5px;
    height:20px;
    width:20px;
    border-radius:5px;
    background-color:gray;
    z-index:999;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layouts/bootstrapgrid/bootstrapgrid.layout.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,SAAS;IACT,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".grid{\n  width:100%;\n  height:100%;\n}\n\n.editItem {\n  border: 1px solid black;\n  align-content: center;\n  min-width: 20px;\n  min-height: 20px;\n}\n\n.dragPoint{\n    position:absolute;\n    top:5px;\n    right:5px;\n    height:20px;\n    width:20px;\n    border-radius:5px;\n    background-color:gray;\n    z-index:999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
